import type {
  AccessAlarm,
  AccessReviewRow,
  AccessReviewWindow,
} from "@care-by-ella/contracts";
import { API_BASE, apiFetch, tenantHeader, withCredentials } from "./api";
import { commonHeaders, jsonOr401 } from "./clinician-api";

// TES-700 — the client for the access review (admin-only endpoint).

export class AccessReviewApiError extends Error {}

async function get<T>(path: string): Promise<T> {
  const res = await apiFetch(
    `${API_BASE}/employee-api/v1/access-review${path}`,
    {
      headers: tenantHeader(),
      ...withCredentials,
    },
  );
  if (res.status === 401 || res.status === 403) return jsonOr401<T>(res);
  if (!res.ok) throw new AccessReviewApiError(`HTTP ${res.status}`);
  return (await res.json()) as T;
}

export function fetchAccessReview(days: number): Promise<AccessReviewWindow> {
  return get<AccessReviewWindow>(`/summary?days=${days}`);
}

export function fetchAccessEntries(opts: {
  employeeId: string;
  days: number;
  onlyWithoutRelationship?: boolean;
}): Promise<AccessReviewRow[]> {
  const q = new URLSearchParams({
    employeeId: opts.employeeId,
    days: String(opts.days),
  });
  if (opts.onlyWithoutRelationship) q.set("onlyWithoutRelationship", "true");
  return get<AccessReviewRow[]>(`/entries?${q.toString()}`);
}

// TES-700 — the alarms raised from the log: open ones first, then those
// acknowledged within the window.
export function fetchAccessAlarms(days: number): Promise<AccessAlarm[]> {
  return get<AccessAlarm[]>(`/alarms?days=${days}`);
}

export async function acknowledgeAccessAlarm(id: string): Promise<AccessAlarm> {
  const res = await apiFetch(
    `${API_BASE}/employee-api/v1/access-review/alarms/${id}/acknowledge`,
    { method: "POST", headers: commonHeaders(), ...withCredentials },
  );
  return jsonOr401<AccessAlarm>(res);
}
